import { Navigate } from "react-router-dom";
import Auth from "../utils/AuthUtils";
import { can } from "../utils/permissionUtils";

const RoleProtectedRoute = ({ action = "read", module, children }) => {
  const user = Auth.getUserDetails();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (user.role === "superadmin") {
    return children;
  }

  if (!can(user.permissions, action, module)) {
    return <Navigate to="/403" replace />;
  }

  return children;
};

export default RoleProtectedRoute;
